import React from "react";
import Autorization from "../components/Autorization";

export const Login = () => {
  return <Autorization method="Login" />;
};

export const Register = () => {
  return <Autorization method="Register" />;
};
